import { CdrState } from "./cdr.model";
import * as paginationConstants from '../../../shared/constants/pagination.constants';
import { createReducer, on } from "@ngrx/store";
import * as cdrsActions from './cdr.actions';

export const cdrsInitialState: CdrState = {
    loading: false,
    error: null,
    cdrs: [],
    cdrMetadata: null,
    cdrsPage: null,
    cdrsPagination: {
        pageIndex: 0,
        pageSize: paginationConstants.DefaultPageSize,
    },
    cdrFilterParameters: null,
    cdrFilter: null,
    cdrRequest: null
}

export const cdrsReducer = createReducer(
    cdrsInitialState,
    on(cdrsActions.loadCdrList, (state) => ({
        ...state,
        loading: true
    })),
    on(cdrsActions.loadCdrListSuccess, (state, { cdrResponse }) => ({
        ...state,
        loading: false,
        cdrs: cdrResponse.result ?? [],
        cdrMetadata: cdrResponse.metadata ?? null,
        cdrsPage: {
            ...state.cdrsPage,
            pageIndex: cdrResponse.pageIndex ?? 0,
            pageSize: cdrResponse.pageSize ?? 0,
            totalCount: cdrResponse.total ?? 0
        }
    })),
    on(cdrsActions.loadCdrListFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error.errorMessage ?? 'ERROR'
    })),
    on(cdrsActions.changeCdrPagination, (state, { pageIndex, pageSize }) => ({
        ...state,
        cdrsPagination: {
            pageIndex: pageIndex,
            pageSize: pageSize
        }
    })),
    on(cdrsActions.changeCdrRequest, (state, { cdrRequest }) => ({
        ...state,
        cdrRequest: {
            ...cdrRequest
        }
    })),
    on(cdrsActions.loadCdrFilterParameters, (state) => ({
        ...state,
        loading: true,
        cdrFilterParameters: null
    })),
    on(cdrsActions.loadCdrFilterParametersSuccess, (state, { cdrFilters }) => ({
        ...state,
        loading: false,
        cdrFilterParameters: {
            ...cdrFilters,
        }
    })),
    on(cdrsActions.loadCdrFilterParametersFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error.errorMessage ?? 'ERROR'
    })),
    on(cdrsActions.changeCdrFilter, (state, {cdrFilter}) => ({
        ...state,
        cdrFilter: {
            ...cdrFilter
        }
    }))
)